import React from 'react';
import { Box } from '@mui/material';
import {
  ELEMENT_LIST_WIDTH_CSS,
  ELEMENT_LIST_RESIZE_HANDLE_CLASS,
  useElementListColumnResizeHandle,
} from './element-list-column-resize.hook';
import { ELEMENT_LIST_HEADER_HEIGHT } from './element-list.constants';

/** Shared resizable header row for Build and project lists. */
export const ElementListHeaderLayout: React.FC<{
  left: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  backgroundColor?: string;
}> = ({ left, children, className, backgroundColor = 'warmSurface.main' }) => {
  const handleDragStart = useElementListColumnResizeHandle();
  return (
    <Box
      className={className}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 4,
        height: ELEMENT_LIST_HEADER_HEIGHT,
        flexShrink: 0,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        bgcolor: backgroundColor,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          height: '100%',
          width: ELEMENT_LIST_WIDTH_CSS,
          overflow: 'hidden',
          boxShadow: 'inset -1px 0 0 rgba(0,0,0,0.1)',
        }}
      >
        {left}
        <Box
          className={ELEMENT_LIST_RESIZE_HANDLE_CLASS}
          onMouseDown={handleDragStart}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: 4,
            cursor: 'ew-resize',
          }}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          pl: '8px',
          gap: '4px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
